var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-icon_by_tooltip" },
    [
      _vm.isShow
        ? _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                placement: _vm.data.placement || "top",
                content: _vm.data.label,
                enterable: false,
              },
            },
            [
              _c(
                "div",
                {
                  class: [
                    "icon_class_wrap",
                    _vm.data.isCopy ? "is-copy" : "",
                    _vm.data.icon ? "filter_padding" : "",
                    _vm.data.icon,
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return (() => {
                        _vm.isShow = false
                        _vm.$nextTick(() => {
                          _vm.isShow = true
                        })
                        if (_vm.data.isCopy) {
                          return
                        }

                        if (
                          _vm.data.icon &&
                          _vm.data.icon.indexOf("copyIcon") >= 0
                        ) {
                          const value = _vm.copyValue.replace(/<\/br>/g, "\n")
                          _vm.tool.copy(value, "textarea", _vm._this)
                        }

                        _vm.$emit("on-click")
                      }).apply(null, arguments)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "icon ordinary",
                    attrs: {
                      src: require("@/components/aiChat/images/icon/" +
                        _vm.data.icon +
                        ".png"),
                    },
                  }),
                  _c("img", {
                    staticClass: "icon hover",
                    attrs: {
                      src: require("@/components/aiChat/images/icon/" +
                        _vm.data.icon +
                        "_h.png"),
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }